import {Case} from '../../../beans/Case';
import {Nomenclature} from '../../../beans/Nomenclature';
import {FrxBaseBean} from '../../../beans/frxbasebean';
import {Income} from '../../../beans/income';
import {BlockUiService} from '../../../services/blockui.service';
import {CaseService} from '../../../services/case.service';
import {NomenclatureService} from '../../../services/nomenclature.service';
import {EditCaseComponent} from '../edit-case.component';
import { DatePipe } from '@angular/common';
import {Component, OnInit, ViewContainerRef, Host, Input} from '@angular/core';

@Component({
	selector: 'app-edit-case-prihodi',
	templateUrl: './edit-case-prihodi.component.html',
	styleUrls: ['./edit-case-prihodi.component.scss']
})
export class EditCasePrihodiComponent implements OnInit {
	[x: string]: any;

	private _caseid;

	amount: number;
	note: string;
	incomeGround: Nomenclature;

	incomeGrounds: Array<Nomenclature>;


	oldIncomes: Array<Income> = new Array();
	totalAmount: number;

	public cols = [
		{title: 'Дата', name: 'createdDate', dataType: 'date'},
		{title: 'Основание', name: 'incomeGround', dataType: 'object', complexDataType: {object: true, displayValue: 'name'}},
		{title: 'Бележка', name: 'note'},
		{title: 'Сума', name: 'amount', dataType: 'currency'},
		{title: 'Потребител', name: 'createdBy'},
	];

	constructor(
		private caseService: CaseService,
		private damageService: NomenclatureService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private datepipe: DatePipe,
		@Host() private parentComp: EditCaseComponent, ) {}

	ngOnInit() {
		this.loadNomenclatures();
		this.loadTable();
	}

	loadTable() {
		this.blockUi.start(this.vcRef);
		this.oldIncomes = new Array<Income>();
		this.caseService.getIncomes(this._caseid).subscribe(
			notes => {
				this.oldIncomes = notes;
				this.blockUi.stop();
				this.totalAmount = 0;
				this.oldIncomes.forEach(pa => {this.totalAmount = this.totalAmount + pa.amount; } );

			},
			error => {
				this.blockUi.stop();
			});
	}


	public delete(obj) {
		if (confirm('Сигурни ли сте, че искате да изтриете приходът?')) {
			this.blockUi.start(this.vcRef);
			this.caseService.deleteIncome(obj.id).subscribe(
				result => {
					this.loadTable();
					this.blockUi.stop();
				},
				error => {
					this.blockUi.stop();
				});
		}
	}

	@Input()
	public set editedCase(val: Case) {
		this.edit(val);
	}

	private refresh() {
		this.amount = null;
		this.note = null;
		this.incomeGround = null;
	}

	private edit(caseObj: Case): void {
		this.refresh();
		if (caseObj && caseObj.id) {
			this._caseid = caseObj.id;
		}
	}

	private loadNomenclatures() {
		this.loadIncomeGrounds();
	}

	private loadIncomeGrounds() {
		this.blockUi.start(this.vcRef);
		this.incomeGrounds = new Array<Nomenclature>();
		this.damageService.getIncomeGrounds().subscribe(incomeGrounds => {
			this.incomeGrounds = incomeGrounds;
			this.blockUi.stop();
		},
			error => {
				this.blockUi.stop();
			});
	}

	public addIncome() {
		const obj = new Income();
		obj.amount = this.amount;
		obj.note = this.note;
		obj.incomeGround = this.incomeGround;
		this.blockUi.start(this.vcRef);
		this.caseService.addIncome(obj, this._caseid).subscribe(
			result => {
				this.blockUi.stop();
				alert('Приходът беше създаден');
				this.refresh();
				this.loadTable();
			},
			error => {
				alert('Възникна Грешка');
				this.blockUi.stop();
			});
	}

	// TODO: This should be in a separate service.. not copy-pasted in each component.... too lazy, don't care
	compareFrxObjects(o1: FrxBaseBean, o2: FrxBaseBean) {
		if (o1 && o2) {
			return o1.id === o2.id;
		}
	}


}
